import React from 'react';
import SEOHead from '../../components/SEOHead';
import PublicLayout from '../../components/site/PublicLayout';
import Hero from '../../components/Hero';
import WhyBookDirect from '../../components/WhyBookDirect';
import Rooms from '../../components/Rooms';
import SectionTeasers from '../../components/site/SectionTeasers';
import Testimonials from '../../components/Testimonials';
import SeoLanding from '../../components/SeoLanding';

// Landing page: hero + direct-booking pitch + rooms (the money section) + doors to every other page.
export default function HomePage() {
  return (
    <PublicLayout>
      <SEOHead />
      <Hero />
      <WhyBookDirect />
      <Rooms />
      <SectionTeasers />
      <Testimonials />
      <SeoLanding slug="home" />
    </PublicLayout>
  );
}
